import { Dispatch, SetStateAction, createContext } from 'react';
import { ROLE_ACCESS } from '../constant/storage';
import { EPostType, IPost } from '../interfaces/post.interface';
import { FolderStatusEnum } from '../interfaces/training.interface';

const defaultValue: IPost = {
  group: {
    name: '',
    avatar: '',
    userRole: ROLE_ACCESS.Revoked,
    groupId: '',
    status: FolderStatusEnum.Private,
    slug: '',
  },
  owner: {
    avatar: null,
    name: '',
    academicRank: null,
    userId: '',
    slug: '',
    hasBlueTick: false,
  },
  createdAt: '',
  isOwner: false,
  hashTags: [],
  title: '',
  content: '',
  postId: '',
  react: 0,
  isReact: false,
  images: [],
  sharesCount: 0,
  type: EPostType.Post,
  commentCount: 0,
  isRecruitExpired: false,
  isRecruitStarted: false,
  lastSubmittedAt: null,
  startDate: null,
  endDate: null,
  allowUploadedFile: false,
  readingTime: 0,
};

export const PostContext = createContext<
  IPost & {
    isLocked: boolean;
    setLastSubmittedAt: Dispatch<SetStateAction<string | null>>;
    defaultLastSubmittedAt: string | null;
  }
>({
  ...defaultValue,
  isLocked: false,
  setLastSubmittedAt: () => {},
  defaultLastSubmittedAt: null,
});
